module.exports = __webpack_public_path__ + "media/images/menu_l_on-184c14811fdb26020b3c0b1739303a0d.gif";